import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import utils from 'utils';
import { actionType, modalActionType } from 'utils/constants';

import CommonButton from 'components/Buttons/CommonButton';
import selectors from 'state/selectors';
import actions from 'state/actions';
import services from 'services';
import axios from 'axios';

const DeleteOpenWfNotification = () => {
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();

  const selectedRow = useSelector(selectors.configurator.getSelectedOpenWfSettings);
  const rows = useSelector(selectors.configurator.getListOfOpenWfSettings);
  const formMode = useSelector(selectors.configurator.getFormModeOpenWf);

  const deleteRow = async () => {
    if (!selectedRow) return;
    try {
      await services.deleteOpenWfNotificationSettings(selectedRow?.idUser);
      dispatch(
        actions.configurator.setListOfOpenWfSettings(
          (rows as any[]).filter((row) => row.idUser !== selectedRow?.idUser),
        ),
      );
      utils.app.notify('success', t('delete_openworfklow_success'));
    } catch (error) {
      if (axios.isAxiosError(error)) {
        utils.app.notify('fail', `${t('error')} ${error.response}`);
        return;
      }
      console.error(error);
    } finally {
      dispatch(actions.modal.closeModal());
    }
  };

  return (
    <CommonButton
      id="delete-open-wf-notification"
      action={() =>
        dispatch(
          actions.modal.setModal({
            actionType: modalActionType.configurator.DELETE_CONFIRMATION,
            props: {
              subtitle: t('delete-openworkflow-setting'),
              func: async () => await deleteRow(),
            },
          }),
        )
      }
      scope="tertiary"
      value={t(actionType.DELETE_OPEN_WF_NOTIFICATIONS)}
      customIcon="trash"
      disabled={
        !utils.user.isActionByCompanyActive(actionType.DELETE_OPEN_WF_NOTIFICATIONS) || !selectedRow || !!formMode
      }
    />
  );
};

export default DeleteOpenWfNotification;
